<script lang="ts">
  import { pageTitle } from "../stores/store";
  import page from "page";

  page.redirect("/projects");
</script>

<h1>Home page</h1>
<p><a href="/projects">Projects</a></p>
